var path = '/components/pdf-popup-popover.html';
var html = "<pdf-selection-popup\n  target=\"$ctrl.target\"\n></pdf-selection-popup>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;